import { Image, Textarea } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { AccordionItem, AccordionItemContent, AccordionItemTrigger, AccordionRoot } from '@/components/ui/accordion'
import { Box } from '@/components/ui/box'
import { HStack } from '@/components/ui/stack'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'

const AdvancedQuota = ({
    total,
    remaining,
    onMessageSet,
}: {
    total: string
    remaining: string
    onMessageSet: (message: string) => void
}) => {
    const { t } = useTranslation()
    const color = useColorModeValue('var(--chakra-colors-gray-500)', 'var(--chakra-colors-white)')
    const panelBackGround = useColorModeValue('var(--chakra-colors-gray-100)', 'transparent')
    const textAreaBackGround = useColorModeValue('var(--chakra-colors-white)', 'transparent')

    return (
        <AccordionRoot multiple mb="24px" pt="40px" border="none">
            <AccordionItem border="none" value={t('global.quotas.drawer.body.title')}>
                <AccordionItemTrigger px="24px" pt="0" _hover={{ backgroundColor: 'transparent' }}>
                    <Image src="/assets/advanced_settings.svg" alt="GSK Logo" height="18px" />
                    <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        ml="18px"
                        fontSize="12px"
                        color={color}
                        textTransform="uppercase"
                        letterSpacing="1px"
                    >
                        {t('global.quotas.drawer.body.title')}
                    </Box>
                </AccordionItemTrigger>
                <AccordionItemContent
                    pl="0"
                    pr="0"
                    backgroundColor={panelBackGround}
                    fontSize="14px"
                    fontFamily="GSKPrecision-Bold"
                    letterSpacing="0.25px"
                    px="24px"
                >
                    <HStack justifyContent="space-between" mb="8px">
                        <Text>{t('global.quotas.drawer.body.total')}</Text>
                        <Text>¤{total}</Text>
                    </HStack>
                    <HStack justifyContent="space-between">
                        <Text>{t('global.quotas.drawer.body.remaining')}</Text>
                        <Text>¤{remaining}</Text>
                    </HStack>
                    <Box divideY="2px" mt="24px" mb="24px" backgroundColor="var(--chakra-colors-gray-100)" />
                    <Text fontSize="14px" fontFamily="GSKPrecision-Bold" letterSpacing="0.25px" mb="16px">
                        {t('global.quotas.drawer.body.description')}
                    </Text>
                    <Textarea
                        onChange={(e) => onMessageSet(e.target.value)}
                        variant="gsk"
                        style={{ caretColor: 'var(--chakra-colors-orange-400)' }}
                        maxH="90%"
                        minH="228px"
                        backgroundColor={textAreaBackGround}
                    />
                </AccordionItemContent>
            </AccordionItem>
        </AccordionRoot>
    )
}

export default AdvancedQuota
